import { reactive } from 'vue'

const storedMode = import.meta.env.DEV && typeof window !== 'undefined'
    ? localStorage.getItem('dev:MyWealthMode')
    : null

const MyWealthMode = storedMode !== null ? storedMode === 'true' : import.meta.env.VITE_MY_WEALTH_MODE === 'true'

export const APP = reactive({
    MyWealthMode,
    MyWealthWebsite: import.meta.env.VITE_MWI_SITE_URL,
    MyWealthPrivateWebsite: import.meta.env.VITE_MWP_SITE_URL,
    CdnBaseUrl: import.meta.env.VITE_CDN_BASE_URL,
    CdnMwiBaseUrl: import.meta.env.VITE_CDN_MWI_BASE_URL,
    CdnMwpBaseUrl: import.meta.env.VITE_CDN_MWP_BASE_URL,
    OpenBankingCallbackUrl: import.meta.env.VITE_OPEN_BANKING_CALLBACK_URL,
    ShowPaymentOptions: import.meta.env.VITE_SHOW_PAYMENT_OPTIONS == 'true',
    WordPressURL: import.meta.env.WAW_WORDPRESS_URL,
    DoBVerifyClientGroups: ["ADVISED","advised"],
    FutureTargetRetirementAgeFrom: import.meta.env?.VITE_FUTURE_TARGET_RETIREMENT_AGE_FROM ?? 55,
    FutureTargetRetirementAgeTo: import.meta.env?.VITE_FUTURE_TARGET_RETIREMENT_AGE_TO ?? 57,
    FutureTargetRetirementDate: import.meta.env?.VITE_FUTURE_TARGET_RETIREMENT_DATE ?? null,
    DefaultOngoingFeeMaximum: import.meta.env.VITE_DEFAULT_ONGOING_FEE_MAXIMUM,
    PensionPhoneNumber: import.meta.env.VITE_PENSION_PHONE_NUMBER,
    BtClientSource: import.meta.env.VITE_BT_CLIENT_SOURCE,
    InactivityTimeoutSeconds: import.meta.env?.VITE_INACTIVITY_TIMEOUT_SECONDS ?? 300,
    MinimumRetentionPortfolioValue: import.meta.env?.VITE_MIN_RETENTION_PORTFOLIO_VALUE ?? 25,

    // Use these with `useAppConfigForCurrentClient` to get per-client allow/blocklist value
    PensionsFeatureEnabled: import.meta.env.VITE_PENSIONS_FEATURE_ENABLED,
    PensionsCreationEnabled: import.meta.env.VITE_PENSIONS_CREATION_ENABLED,
});

export function setMyWealthMode(value) {
    if (import.meta.env.DEV) {
        APP.MyWealthMode = !!value
        localStorage.setItem('dev:MyWealthMode', !!value)
    }
}

if (import.meta.env.DEV && typeof window !== 'undefined') {
    window.setMyWealthMode = setMyWealthMode
}